(function() {

	'use strict';

	angular.module('Services').service('NonManifestedByLocationTableService', NonManifestedByLocationTableService);

	NonManifestedByLocationTableService.$inject = ['Shipments', 'TableLiteFactory', 'CommonService'];

	function NonManifestedByLocationTableService(Shipments, TableLiteFactory, CommonService) {

		var tableData = {};

		var activeFilters = {};
		var paginationFilter = {};
		var sortingFilter = {
			page: 0
		};
		var carrierFilters = [];

		var tableStructure = {
			optionAddOns: {
                title: 'BBA Mastro',
            },
            headers: [{
                label: 'Location',
                viewName: 'location',
                filterName: 'location',
                filter: {
                    type: 'inputDropdown',
                    placeholder: 'Search',
                    class: 'table-input',
                    items: [{viewName: 'Australia'}, {viewName: 'Canada'}],
                    onSelect: function(){
                        //console.log(this);
                    }
                }
            }, {
                label: 'Hours Since Booked',
                viewName: 'hours_since_booked',
                filterName: 'hours_since_booked',
                filter: {
                    type: 'text',
                    placeholder: 'Search'
                }
            }, {
                label: 'Number of Non-Manifested Shipments',
                viewName: 'non_manifested_no',
                filterName: 'non_manifested_no',
                filter: {
                    type: 'text',
                    placeholder: 'Search'
                }
            }, {
                label: 'Total Amount (Sell) Ex Tax',
                viewName: 'amount_ex_tax',
                filterName: 'amount_ex_tax',
                filter: {
                    type: 'text',
                    placeholder: 'Search'
                }
            }],
			data: [],
			applyFilters: function(item) {
				angular.extend(paginationFilter, {
					size: item,
					page: 0
				});
				sendRequest();
			},
			extractTable: function(form) {

			},
			onPageChanged: function() {
				angular.extend(paginationFilter, {
					page: this.currentPage - 1
				});
				sendRequest();
			},
			rowOnClick: function(item) {},
			resetFilters: resetFilters,
			onInit: function() {
                sendRequest({
                    size: 10,
                    page: 0,
                    sort: 'createdDate,desc'
                });
            },
			totalItems: 2,
			numberOfItems: 10,
			totalPages: 1,
			itemView: 20,
			itemViewRaw: 20,
			currentPage: 1
		};

		function sort(filterName) {
			if (tableData.sort && tableData.sort[0].property !== filterName) {
				sortingFilter.sort = filterName;
			} else if (!tableData.sort || tableData.sort[0].property == filterName &&
				!tableData.sort[0].direction.toLowerCase() == 'desc') {
				sortingFilter.sort = filterName;
			} else if (tableData.sort[0].direction.toLowerCase() == 'asc') {
				sortingFilter.sort = filterName + ',desc';
			} else if (tableData.sort[0].direction.toLowerCase() == 'desc') {
				delete sortingFilter.sort;
				delete paginationFilter.sort;
				delete activeFilters.sort;
			}

			sendRequest(sortingFilter);
		}
        function resetFilters () {
            angular.forEach(tableStructure.headers, function(header){
                if(header.filter.model)
                    header.filter.model = '';
                if(header.filter.toModel)
                    header.filter.toModel = '';
                if(header.filter.fromModel)
                    header.filter.fromModel = '';
                delete activeFilters[header.filterName];
            });
            sendRequest({});
        };
		function evaluateFilter(header) {
			var filter = {};
			if (header.filter.model)
				filter[header.filterName] = header.filter.model;
			else if (activeFilters[header.filterName])
				delete activeFilters[header.filterName];

			return filter;
		}

		function sendRequest(filter) {
			angular.extend(activeFilters, paginationFilter, filter);
			Shipments.getNonManifested(function(data) {
				tableData = buildTableData(data, activeFilters);
			}, function(err) {
			    tableData = buildTableData(null, activeFilters);
			    console.log(err);
			}, activeFilters);
		};

		function buildTableData(data, pagination, filters, filter) {
			/*** START - Building of Data ***/
			if (pagination)
				paginationFilter = pagination;

			tableData = tableStructure;
			tableData.data = [];
			
			if(filters){
				for (var i = 0; i < tableData.headers.length; i++) {
					if(tableData.headers[i].viewName === 'titleLogo'){
						tableData.headers[i].filter.items = filters;
						tableData.headers[i].filter.model = filter;
					}
				}
			}

			angular.extend(tableData, TableLiteFactory.getCommonProperties(data));
            if(!data)
                return tableData;
			angular.forEach(data.content, function(row) {
				row.href = '/manifests/non-manifested-by-carrier/1';
				tableStructure.data.push(row);
			});
			/*** END - Building of Data ***/

			return tableData;
		};
		return tableStructure;
	};
})();



// WEBPACK FOOTER //
// ./js/services/tables/NonManifestedByLocationTableService.js